import { Route, Switch } from 'react-router';
import Master_Main from './Master/Master-Main';
import { MobiOrNotContextProvider } from './Contexts/MobiOrNot_Context';
import { RestMenuContextProvider } from './Contexts/RestMenu_Context';
import { SideMenuContextProvider } from './Contexts/SideMenu_Context';
import { TheOrderContextProvider } from './Contexts/TheOrder_Context';
import { MasterContextProvider } from './Contexts/Master_Context';
import { UserContextProvider } from './Contexts/User_Context';
import { SpecialUserContextProvider } from './Contexts/SpecialUser_Context';
import MasterHead from "./Master/MasterHeads";
import { CurrentPContextProvider } from './Contexts/CurrentP_Context';

function App() {
  return (
    <MobiOrNotContextProvider>
      <MasterContextProvider>
        <UserContextProvider>
          <CurrentPContextProvider>
            <SpecialUserContextProvider>
              <SideMenuContextProvider>
                <RestMenuContextProvider>
                  <TheOrderContextProvider>
                    <MasterHead />
                    <Master_Main />
                  </TheOrderContextProvider>
                </RestMenuContextProvider>
              </SideMenuContextProvider>
            </SpecialUserContextProvider>
          </CurrentPContextProvider>
        </UserContextProvider>
      </MasterContextProvider>
    </MobiOrNotContextProvider>
  );
}

export default App;
